import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f36f8eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container hidden-print" }
const _hoisted_2 = { class: "row my-2 my-lg-3" }
const _hoisted_3 = { class: "col-md-6 col-lg-5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = ["href", "title"]
const _hoisted_10 = { class: "col-md-6 col-lg-7 d-flex h-100 flex-column align-items-start flex-lg-row justify-content-lg-end flex-wrap-reverse" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  class: "col-12"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "col-12"
}
const _hoisted_16 = {
  key: 1,
  class: "col-12"
}
const _hoisted_17 = { class: "d-flex justify-content-between flex-wrap" }
const _hoisted_18 = {
  key: 1,
  class: "wallet-message p-message p-component"
}
const _hoisted_19 = { class: "p-message-wrapper justify-content-between flex-wrap" }
const _hoisted_20 = { class: "d-flex align-items-center mb-1 mb-lg-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-1",
  height: "46",
  width: "46"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-wallet" })
], -1))
const _hoisted_22 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_23 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_24 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_25 = {
  key: 2,
  class: "wallet-message p-message p-component"
}
const _hoisted_26 = { class: "p-message-wrapper justify-content-between flex-wrap" }
const _hoisted_27 = { class: "d-flex align-items-center mb-1 mb-lg-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-1",
  height: "46",
  width: "46"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-wallet" })
], -1))
const _hoisted_29 = { class: "text-primary" }
const _hoisted_30 = {
  key: 0,
  class: "container hidden-print"
}
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "d-flex w-100" }
const _hoisted_33 = { class: "d-flex flex-column w-100" }
const _hoisted_34 = {
  key: 0,
  class: "wallet-earning"
}
const _hoisted_35 = {
  class: "left-container",
  style: {'background-image': `url('/Static/images/yaron1.png')`}
}
const _hoisted_36 = { class: "help-text" }
const _hoisted_37 = { class: "contact-info" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone pr-1" }, null, -1))
const _hoisted_40 = { class: "d-flex flex-column mx-2" }
const _hoisted_41 = { class: "d-flex justify-content-between" }
const _hoisted_42 = { class: "text-primary" }
const _hoisted_43 = {
  key: 0,
  class: "p-badge p-badge-primary"
}
const _hoisted_44 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "text-bold mr-2" }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = {
  key: 0,
  class: "col-lg-6 col-xl-6 col-xxl-5 ml-auto p-3 right-container"
}
const _hoisted_49 = {
  key: 2,
  class: "wallet-card-container",
  style: {'background-image': `url('/Static/images/stars-background.jpg')`}
}
const _hoisted_50 = { class: "wallet-card-extended w-100" }
const _hoisted_51 = ["alt"]
const _hoisted_52 = { class: "wallet-title" }
const _hoisted_53 = { class: "wallet-text" }
const _hoisted_54 = { class: "d-flex justify-content-end" }
const _hoisted_55 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_56 = { class: "text-bold" }
const _hoisted_57 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_58 = { class: "flex-wrap" }
const _hoisted_59 = { class: "mt-1 align-self-end justify-content-between" }
const _hoisted_60 = {
  key: 3,
  class: "visible-print"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_CartOverview = _resolveComponent("CartOverview")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CartPageSummary = _resolveComponent("CartPageSummary")!
  const _component_SaveCartModal = _resolveComponent("SaveCartModal")!
  const _component_ShareCartModal = _resolveComponent("ShareCartModal")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_CartPrintPreview = _resolveComponent("CartPrintPreview")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, [
            _createTextVNode(_toDisplayString(_ctx.pageTitle), 1),
            (_ctx.vm.cartTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, ": " + _toDisplayString(_ctx.vm.cartTitle), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.userProfile?.isImpersonated || _ctx.userProfile?.isCadacSales)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.vm.cartOpportunityName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.$t("cart.lblSalesOpportunity")) + ": ", 1),
                        _createElementVNode("span", _hoisted_8, [
                          _createElementVNode("a", {
                            href: _ctx.vm.cartOpportunityUrl,
                            title: _ctx.$t('common.goToCrm')
                          }, _toDisplayString(_ctx.vm.cartOpportunityName), 9, _hoisted_9)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cartClient?.itemCount)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "pl-lg-0 p-button-secondary p-button-text flex-shrink-0 hidden-print",
                      icon: "pi pi-envelope",
                      label: _ctx.$t('cart.button.shareCart'),
                      title: _ctx.$t('cart.button.shareCart'),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShareCartClick()))
                    }, null, 8, ["label", "title"]))
                  : _createCommentVNode("", true),
                (_ctx.cartClient?.itemCount)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "pl-lg-0 p-button-secondary p-button-text flex-shrink-0 hidden-print",
                      icon: "pi pi-file-pdf",
                      label: _ctx.$t('cart.button.printInvoice'),
                      title: _ctx.$t('cart.button.printInvoice'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPrintInvoiceClick()))
                    }, null, 8, ["label", "title"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.showOtherCartsButton)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                badge: _ctx.vm.totalNumberOfShoppingCarts.toString(),
                "badge-class": "p-badge-primary",
                class: "p-button-primary p-button-text flex-shrink-0",
                disabled: _ctx.isBusy,
                icon: "pi pi-shopping-cart",
                label: _ctx.$t('cart.button.otherCarts'),
                title: _ctx.$t('cart.button.otherCarts'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
						_ctx.openUrl(`${_ctx.vm.myCartsPageUrl}`);
						$event.target.disabled = true;
					})
              }, null, 8, ["badge", "disabled", "label", "title"]))
            : _createCommentVNode("", true),
          (_ctx.showSaveCartButton)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "p-button-primary p-button-text flex-shrink-0",
                disabled: _ctx.isBusy,
                icon: _ctx.vm.cartTitle ? 'pi pi-star-fill' : 'pi pi-star',
                label: _ctx.$t('cart.button.saveCart'),
                title: _ctx.$t('cart.button.saveCart'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSaveCartClick()))
              }, null, 8, ["disabled", "icon", "label", "title"]))
            : _createCommentVNode("", true),
          (!_ctx.cartStore.isCartEmpty)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                class: "p-button-primary p-button-text flex-shrink-0",
                disabled: _ctx.isBusy,
                icon: "pi pi-trash",
                label: _ctx.$t('cart.button.emptyCart'),
                title: _ctx.$t('cart.button.emptyCart'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDeleteCartClick()))
              }, null, 8, ["disabled", "label", "title"]))
            : _createCommentVNode("", true),
          (!_ctx.cartStore.isCartEmpty)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                class: "p-button-primary p-button-text flex-shrink-0",
                disabled: _ctx.isBusy,
                icon: "pi pi-print",
                label: _ctx.$t('cart.button.printCart'),
                title: _ctx.$t('cart.button.printCart'),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPrintCartClick()))
              }, null, 8, ["disabled", "label", "title"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showCartItemsMergedMsg)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            closable: true,
            severity: "info",
            onClose: _cache[6] || (_cache[6] = ($event: any) => {
				_ctx.showCartItemsMergedMsg = false;
				_ctx.cookies.remove('shoppingCartsMerged', { path: '/' });
			})
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cart.message.itemsMerged")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.vm.announcements.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.announcements.items, (announcement, index) => {
                return (_openBlock(), _createBlock(_component_Message, {
                  key: index,
                  closable: true,
                  severity: "info"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: announcement.body
                    }, null, 8, _hoisted_13)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (!_ctx.cartStore.isCartEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_CartOverview, { "cart-client": _ctx.cartClient }, null, 8, ["cart-client"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_Message, {
                closable: false,
                severity: "warn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("cart.message.noItemsInCart")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_17, [
                (_ctx.vm.totalNumberOfShoppingCarts && _ctx.vm.myCartsPageUrl)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      badge: _ctx.vm.totalNumberOfShoppingCarts.toString(),
                      "badge-class": "p-badge-primary",
                      class: "p-button-primary p-button-outlined p-button-lg flex-shrink-0 mb-2",
                      icon: "pi pi-shopping-cart",
                      label: _ctx.$t('cart.button.otherCarts'),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {
							_ctx.openUrl(`${_ctx.vm.myCartsPageUrl}`);
							$event.target.disabled = true;
						})
                    }, null, 8, ["badge", "label"]))
                  : _createCommentVNode("", true),
                (_ctx.vm.softwareOverviewUrl)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-primary p-button-lg flex-shrink-0 mb-2",
                      icon: "pi pi-arrow-right",
                      "icon-pos": "right",
                      label: _ctx.$t('cart.button.continueShopping'),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => {
							_ctx.openUrl(`${_ctx.vm.softwareOverviewUrl}`);
							$event.target.disabled = true;
						})
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      (_ctx.canExchangeWallet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                (!_ctx.cartStore.hasActiveWalletCoupon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createVNode(_component_i18n_t, { keypath: "cart.lblYouCanExchangeWalletAmount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.cartStore.maxWalletAmount)), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                      _createVNode(_component_i18n_t, { keypath: "cart.lblYouHaveExchangedWalletAmount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.cartStore.walletExchangeAmount)), 1)
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _createElementVNode("div", null, [
                (!_ctx.cartStore.hasActiveWalletCoupon)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-primary",
                      label: _ctx.$t('cart.button.addWalletCoupon'),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onExchangeWalletClick($event)))
                    }, null, 8, ["label"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartClient.appliedCouponCodes, (coupon, index) => {
                        return (_openBlock(), _createBlock(_component_Button, {
                          key: index,
                          class: "p-button-danger p-button-text",
                          disabled: _ctx.isSpinnerVisible('btnRemoveCoupon'),
                          icon: _ctx.isSpinnerVisible('btnRemoveCoupon') ? 'pi pi-spinner' : 'pi pi-times',
                          "icon-pos": "right",
                          label: _ctx.$t('cart.button.removeWalletCoupon'),
                          loading: _ctx.isSpinnerVisible('btnRemoveCoupon'),
                          title: _ctx.$t('cart.button.removeWalletCoupon'),
                          onClick: ($event: any) => (_ctx.removeCouponCode(coupon))
                        }, null, 8, ["disabled", "icon", "label", "loading", "title", "onClick"]))
                      }), 128))
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.walletUnavailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("cart.lblWalletNotAvailable")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.cartStore.isCartEmpty)
      ? (_openBlock(), _createBlock(_component_CartPageSummary, {
          key: 0,
          "button-text": _ctx.$t('cart.button.goToCheckout'),
          "can-submit": _ctx.canCheckout || !_ctx.isSpinnerVisible('priceSummary'),
          "total-price": _ctx.priceSummary?.totalPrice,
          onClickAction: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onCheckoutClick()))
        }, {
          priceSummary: _withCtx(() => [
            _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"])
          ]),
          card: _withCtx(() => [
            (_ctx.cartClient?.itemCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Card, { class: "mb-3 shadow-none" }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "d-flex",
                          style: _normalizeStyle({
									'min-height': _ctx.isSmallScreen ? '' : '300px',
								})
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              (_ctx.cartClient?.totalWalletAmountEarned)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createVNode(_component_i18n_t, { keypath: "cart.lblWalletAmountEarned" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.cartClient?.totalWalletAmountEarned)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t("common.support.helpTitle")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("common.support.helpText")), 1),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("span", null, [
                                      _createElementVNode("a", {
                                        href: 'tel:' + _ctx.$t('common.support.phoneNumber')
                                      }, [
                                        _hoisted_39,
                                        _createTextVNode(_toDisplayString(_ctx.$t("common.support.phoneNumber")), 1)
                                      ], 8, _hoisted_38)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_Accordion, {
                                    "active-index": _ctx.couponFormActiveIndex,
                                    "onUpdate:activeIndex": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.couponFormActiveIndex) = $event)),
                                    ref: "couponForm",
                                    class: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_AccordionTab, {
                                        disabled: !_ctx.layoutStore.isAuthenticated
                                      }, {
                                        header: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("cart.lblCouponForm")), 1),
                                            (_ctx.cartStore.hasActiveCoupon)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.cartClient.appliedCouponCodes.length), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          (_ctx.canExchangeCoupon && !_ctx.cartStore.hasActiveCoupon)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                _createVNode(_component_InputText, {
                                                  modelValue: _ctx.couponCode,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.couponCode) = $event)),
                                                  placeholder: _ctx.$t('cart.couponForm_placeholder')
                                                }, null, 8, ["modelValue", "placeholder"]),
                                                _createVNode(_component_Button, {
                                                  class: "p-button-primary",
                                                  disabled: _ctx.isSpinnerVisible('btnSubmitCoupon'),
                                                  icon: "pi pi-check",
                                                  loading: _ctx.isSpinnerVisible('btnSubmitCoupon'),
                                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addCouponCode()))
                                                }, null, 8, ["disabled", "loading"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.canExchangeCoupon && _ctx.cartStore.hasActiveCoupon)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("cart.lblActiveCoupon")), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartClient.appliedCouponCodes, (coupon, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: "d-flex align-items-center"
                                                  }, [
                                                    _createElementVNode("span", _hoisted_46, _toDisplayString(coupon.name), 1),
                                                    _createVNode(_component_Button, {
                                                      class: "p-button-danger p-button-text",
                                                      disabled: _ctx.isSpinnerVisible('btnRemoveCoupon'),
                                                      icon: _ctx.isSpinnerVisible('btnRemoveCoupon') ? 'pi pi-spinner': 'pi pi-times',
                                                      "icon-pos": "right",
                                                      label: _ctx.$t('cart.button.removeCoupon'),
                                                      loading: _ctx.isSpinnerVisible('btnRemoveCoupon'),
                                                      title: _ctx.$t('cart.button.removeCoupon'),
                                                      onClick: ($event: any) => (_ctx.removeCouponCode(coupon))
                                                    }, null, 8, ["disabled", "icon", "label", "loading", "title", "onClick"])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _withDirectives(_createElementVNode("p", { class: "p-error" }, _toDisplayString(_ctx.firstErrorMessage), 513), [
                                            [_vShow, _ctx.canExchangeCoupon && _ctx.cartClient.hasError]
                                          ]),
                                          (_ctx.showCouponMessage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("cart.lblCouponNotAvailable")), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["active-index"]),
                                  (!_ctx.layoutStore.isAuthenticated)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "coupon-login",
                                        href: "javascript:void(0)",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToLoginPage()))
                                      }, _toDisplayString(_ctx.$t("cart.lblCouponFormLoggedOut")), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          (!_ctx.isSmallScreen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                (_ctx.isSpinnerVisible('priceSummary'))
                                  ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                      key: 0,
                                      "animation-duration": ".75s",
                                      class: "d-block ml-auto mr-0",
                                      "stroke-width": "3"
                                    }))
                                  : (_openBlock(), _createBlock(_component_PriceSummary, {
                                      key: 1,
                                      vm: _ctx.priceSummary
                                    }, null, 8, ["vm"])),
                                (_ctx.layoutStore.isAuthenticated && _ctx.vm.autoDeskWalletAmount && parseInt(_ctx.vm.autoDeskWalletAmount) > 0 && _ctx.priceSummary.totalPersonalPrice && parseInt(_ctx.priceSummary.totalPersonalPrice) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _withDirectives(_createElementVNode("img", {
                                          alt: _ctx.vm.autodeskLoyaltyCashbackBlock?.icon?.alt,
                                          class: "wallet-icon"
                                        }, null, 8, _hoisted_51), [
                                          [_directive_lazy, '/Static/images/autodesk-coin.png']
                                        ]),
                                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("cart.autodesk.gift")), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t("cart.autodesk.text", { amount: _ctx.formatCurrency(Math.min(_ctx.vm.autoDeskWalletAmount, _ctx.priceSummary.totalPersonalPrice)) })), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (!_ctx.hasValidProfile)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 3,
                                      closable: false,
                                      severity: "warn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("cart.message.unverifiedEmail")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.vm.userIsPartnerCompany)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 4,
                                      closable: false,
                                      severity: "warn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("cart.message.userIsPartner")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_54, [
                                  _createVNode(_component_Button, {
                                    class: "p-button-success p-button-raised p-button-lg p-button-arrow mt-2 w-100",
                                    disabled: !_ctx.canCheckout || _ctx.isSpinnerVisible('priceSummary'),
                                    label: _ctx.$t('cart.button.goToCheckout'),
                                    loading: _ctx.isBusy,
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCheckoutClick()))
                                  }, null, 8, ["disabled", "label", "loading"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["button-text", "can-submit", "total-price"]))
      : _createCommentVNode("", true),
    (_ctx.cartStore.showSaveCartModal)
      ? (_openBlock(), _createBlock(_component_SaveCartModal, {
          key: 1,
          "current-title": _ctx.vm.cartTitle,
          onCartSaved: _cache[16] || (_cache[16] = ($event: any) => (_ctx.saveCart($event)))
        }, null, 8, ["current-title"]))
      : _createCommentVNode("", true),
    (_ctx.cartStore.showShareCartModal)
      ? (_openBlock(), _createBlock(_component_ShareCartModal, {
          key: 2,
          vm: _ctx.vm,
          onCartShared: _cache[17] || (_cache[17] = ($event: any) => (_ctx.shareCart($event)))
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      ref: "useWalletPanel",
      dismissable: true,
      "show-close-icon": true
    }, {
      default: _withCtx(() => [
        (!_ctx.cartStore.hasActiveWalletCoupon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t("cart.lblExchangeAmount")), 1),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.cartStore.walletExchangeAmount,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.cartStore.walletExchangeAmount) = $event)),
                    currency: _ctx.currentCurrency,
                    locale: _ctx.currentRegion,
                    max: _ctx.cartStore.maxWalletAmount,
                    "max-fraction-digits": 2,
                    min: 0.01,
                    "min-fraction-digits": 2,
                    mode: "currency"
                  }, null, 8, ["modelValue", "currency", "locale", "max"]),
                  _createElementVNode("small", null, "Max: " + _toDisplayString(_ctx.formatCurrency(_ctx.cartStore.maxWalletAmount)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_Button, {
                  class: "p-button-text",
                  disabled: _ctx.isSpinnerVisible('btnExchangeWallet'),
                  icon: _ctx.isSpinnerVisible('btnExchangeWallet') ? 'pi pi-spinner spin' : 'pi pi-check',
                  label: _ctx.$t('cart.button.exchange'),
                  loading: _ctx.isSpinnerVisible('btnExchangeWallet'),
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.exchangeWalletAmount()))
                }, null, 8, ["disabled", "icon", "label", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    (_ctx.cartClient)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createVNode(_component_CartPrintPreview, {
            "cart-client": _ctx.cartClient,
            "checkout-form": _ctx.vm.checkoutForm,
            "is-invoice": _ctx.printInvoice,
            title: _ctx.vm.cartTitle ? _ctx.vm.cartTitle : _ctx.vm.pageTitle
          }, null, 8, ["cart-client", "checkout-form", "is-invoice", "title"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}